// extracted by mini-css-extract-plugin
export default {"cta":"yH-z","disabled":"zH-z"};